import React, { useId, useRef, useMemo } from 'react';
import classnames from 'classnames';

import config from 'config';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import { Button } from 'components/Misc/Form';

const File = ({ file, path, folder, onRemove }) => {
	// Get file's type
	const type = useMemo(() => {
		const ext = `.${file.name.split('.').pop()}`;

		if (config.extensions.image.includes(ext)) {
			return 'image';
		} else if (config.extensions.audio.includes(ext)) {
			return 'audio';
		} else if (config.extensions.video.includes(ext)) {
			return 'video';
		} else {
			return 'other';
		}
	}, [file]);

	const remove = () => onRemove(file.id);

	return (
		<div className="py-2 px-2 space-x-2 flex items-center border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
			{/* Show preview if image */}
			<Show if={type === 'image'}>
				<Icon
					icon="image"
					className="text-xl text-neutral-700 dark:text-white"
				/>
			</Show>

			{/* Show icon if not image */}
			<Show if={type === 'audio'}>
				<Icon
					icon="audiotrack"
					className="text-xl text-neutral-700 dark:text-white"
				/>
			</Show>

			{/* Show icon if not image */}
			<Show if={type === 'video'}>
				<Icon
					icon="videocam"
					className="text-xl text-neutral-700 dark:text-white"
				/>
			</Show>

			{/* Show icon if not image */}
			<Show if={type === 'other'}>
				<Icon
					icon="insert_drive_file"
					className="text-xl text-neutral-700 dark:text-white"
				/>
			</Show>

			<div className="flex-1 text-neutral-700 dark:text-white whitespace-nowrap text-ellipsis overflow-hidden transition-colors">{file.name}</div>

			<Button
				small
				square
				icon="close"
				className="text-neutral-700 dark:text-white transition-colors"
				onClick={remove}
			/>
		</div>
	);
}; 

const Files = ({ label, name, uploaded, path, folder, onChange, onRemove, className }) => {
	// Generate random id once
	const id = useId();

	// Store input's ref
	const ref = useRef(null);

	// Handle input's value change
	const handle = (event) => {
		onChange({
			name,
			files: event.target.files
		});
		ref.current.value = '';
	};

	// Handle input's focus
	const focus = () => {
		ref.current.click();
	};

	return (
		<div className="space-y-2">
			{/* Show label only if passed */}
			<Show if={label}>
				<label
					htmlFor={id}
					className="mb-1 text-sm font-bold text-neutral-800 dark:text-white transition-colors"
				>
					{label}
				</label>
			</Show>

			<div className="space-y-2">
				{uploaded?.map(file =>
					<File
						key={file.id}
						file={file}
						path={path}
						folder={folder}
						onRemove={onRemove}
					/>
				)}
			</div>

			<Button
				icon="upload"
				theme="informative"
				value="Izvēlēties failus"
				onClick={focus}
			/>

			<input
				id={id}
				ref={ref}
				type="file"
				multiple
				name={name}
				onChange={handle}
				className="hidden"
			/>
		</div>
	);
};

export default Files;